<template>
  <div class="py-3">
    <div v-if="template" class="">
      <ValidationObserver v-slot="{ invalid }">
      <b-form id="questionario" @submit.prevent="sendForm">
        <b-row cols="1" class="align-items-end">
          <transition-group name="list" mode="out-in" appear>
            <template v-for="(domanda, ind) in template.template.domande">
              <template v-if="canBeShown(domanda)">
                <!-- <p :key="'dpt' + ind">
                  {{ domanda }}
                </p> -->

                <!-- //ricognizione //ricognizione patologie //files //opzioni
                (select o checkbox) -->

                <template v-if="domanda.o">
                  <template v-if="domanda.o === 'ricognizione'">
                    <CompilatoreRicognizione
                      :key="'d' + ind"
                      :patient="patient"
                      type="terapie"
                      :template="template.template.ricognizione"
                      @schema-ricognizione="setRicognizioneQuestions($event)"
                    ></CompilatoreRicognizione>

                    <template v-if="schemaRicognizione">
                      <b-row
                        v-for="(therapy, index) in schemaRicognizione"
                        class="px-2 mt-2"
                        :key="index + 'ricognizione' + ind"
                      >
                        <h6
                          class="text-left bg-primary text-white fw-bolder p-2 w-100"
                        >
                          <span class="bg-secondary p-2"
                            >Terapia {{ index + 1 }}.</span
                          >
                          {{ therapy[0].a }}
                        </h6>
                        <b-col>
                          <b-row cols="1" cols-md="2">
                            <b-col v-for="(field, position) in therapy" :key="field.q">
                              <b-form-group
                                class="text-left"
                                :key="'terpos' + position"
                              >
                                <label>{{ field.q }}:</label>
                                <template v-if="field.t === 'select'">
                                  <b-form-select
                                    class="shadow_6 align-self-center"
                                    v-model="
                                      schemaRicognizione[index][position].a
                                    "
                                    :name="'ric_' + index"
                                    required
                                  >
                                    <b-form-select-option
                                      v-for="opt in field.o"
                                      :key="opt"
                                      :value="opt"
                                      >{{ opt }}
                                    </b-form-select-option>
                                    <b-form-select-option :value="null" disabled
                                      >scegli..
                                    </b-form-select-option>
                                  </b-form-select>
                                </template>
                                <template v-else-if="field.t === 'datetime'">
                                  <b-form-input
                                    class="shadow_6"
                                    type="text"
                                    placeholder="GG/MM/AAAA hh:mm"
                                    :name="'ric_' + index"
                                    v-model="
                                      schemaRicognizione[index][position].a
                                    "
                                    :readonly="field.i == false"
                                    v-bind="
                                      field.r && field.i !== false
                                        ? { required: true }
                                        : {}
                                    "
                                  ></b-form-input>
                                </template>
                                <b-form-input
                                  v-else
                                  class="shadow_6"
                                  :type="field.t"
                                  v-model="
                                    schemaRicognizione[index][position].a
                                  "
                                  :readonly="field.i == false"
                                  v-bind="
                                    field.r && field.i !== false
                                      ? { required: true }
                                      : {}
                                  "
                                  :name="'ric_' + index"
                                ></b-form-input>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </template>
                    <b-spinner v-else :key="'ricognizione_spinner_' + ind" :label="$t('caricamento')"></b-spinner>
                  </template>
                  <template v-if="domanda.o === 'ricognizione_patologie'">
                    <CompilatoreRicognizione
                      :key="'d' + ind"
                      :patient="patient"
                      type="patologie"
                      :template="template.template.ricognizione_patologie"
                      @schema-ricognizione="
                        setRicognizionePatologieQuestions($event)
                      "
                    ></CompilatoreRicognizione>

                    <template v-if="schemaRicognizionePatologie">
                      <b-row
                        v-for="(
                          pathology, index
                        ) in schemaRicognizionePatologie"
                        class="px-2 mt-2"
                        :key="index + 'ricognizione_pat' + ind"
                      >
                        <h6
                          class="text-left bg-primary text-white fw-bolder p-2 w-100"
                        >
                          <span class="bg-secondary p-2"
                            >Patologia {{ index + 1 }}.</span
                          >
                          {{ pathology[0].a }}
                        </h6>
                        <b-col>
                          <b-row cols="1" cols-md="2">
                            <b-col v-for="(field, position) in pathology" :key="'patpos' + position">
                              <b-form-group
                                class="text-left"
                                :key="'patpos' + position"
                              >
                                <label>{{ field.q }}:</label>
                                <template v-if="field.t === 'select'">
                                  <b-form-select
                                    class="shadow_6 align-self-center"
                                    v-model="
                                      schemaRicognizionePatologie[index][
                                        position
                                      ].a
                                    "
                                    :name="'ric_' + index"
                                    required
                                  >
                                    <b-form-select-option
                                      v-for="opt in field.o"
                                      :key="opt"
                                      :value="opt"
                                      >{{ opt }}
                                    </b-form-select-option>
                                    <b-form-select-option :value="null" disabled
                                      >scegli..
                                    </b-form-select-option>
                                  </b-form-select>
                                </template>
                                <template v-else-if="field.t === 'datetime'">
                                  <b-form-input
                                    class="shadow_6"
                                    type="text"
                                    placeholder="GG/MM/AAAA hh:mm"
                                    :name="'ric_' + index"
                                    v-model="
                                      schemaRicognizionePatologie[index][
                                        position
                                      ].a
                                    "
                                    :readonly="field.i == false"
                                    v-bind="
                                      field.r && field.i !== false
                                        ? { required: true }
                                        : {}
                                    "
                                  ></b-form-input>
                                </template>
                                <b-form-input
                                  v-else
                                  class="shadow_6"
                                  :type="field.t"
                                  v-model="
                                    schemaRicognizionePatologie[index][position]
                                      .a
                                  "
                                  :readonly="field.i == false"
                                  v-bind="
                                    field.r && field.i !== false
                                      ? { required: true }
                                      : {}
                                  "
                                  :name="'ric_' + index"
                                ></b-form-input>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </template>
                    <b-spinner v-else :key="'ricognizione_pat_spinner_' + ind" :label="$t('caricamento')"></b-spinner>
                  </template>

                  
                  <template v-if="domanda.o && domanda.o === 'file'">
                    <b-row cols="1" class="mb-3" :key="'file_' + ind">
                      <b-col cols="12" class="text-justify">
                        <h6 :for="'q_' + ind">
                          <span class="text-secondary"> {{ ind + 1 }}.</span>
                          {{ domanda.q }}
                          <span v-if="domanda.h" class="mb-0 text-secondary">
                            - domanda per l'operatore</span
                          >
                        </h6>
                      </b-col>
                      <b-col cols="12" class="text-justify">
                        <b-form-group :key="'fgr_' + ind">
                          <div class="align-self-center">
                            <SurveyUploader
                              v-on:upload-result="handleUpload($event, ind)"
                              v-on:remove-result="removeUpload(ind)"
                              :accepts="domanda.fa"
                              :isMulti="domanda.fm"
                            />
                          </div>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </template>
                  <template
                    v-else-if="Array.isArray(domanda.o) && domanda.cb"
                  >
                    <b-row cols="1" class="mb-3" :key="'d' + ind">
                      <b-col cols="12" class="text-justify" :key="'qq_' + ind">
                        <h6>
                          <span class="text-secondary"> {{ ind + 1 }}.</span>
                          {{ domanda.q }}
                          <span v-if="domanda.h" class="mb-0 text-secondary">
                            - domanda per l'operatore</span
                          >
                        </h6>
                      </b-col>
                      <b-col cols="12" class="text-justify">
                        <b-form-group :key="'tfgr_' + ind">
                          <b-form-checkbox-group
                            :name="'q_' + ind"
                            v-model="domanda.a"
                            :options="domanda.o"
                          ></b-form-checkbox-group>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </template>
                </template>
                <template
                  v-if="
                    (Array.isArray(domanda.o) && !domanda.cb) || !domanda.o
                  "
                >
                  <b-row cols="1" class="mb-3" :key="'dom' + ind">
                    <b-col cols="12" class="text-justify">
                      <h6 :for="'q_' + ind">
                        <span class="text-secondary"> {{ ind + 1 }}.</span>
                        {{ domanda.q }}
                        <span v-if="domanda.h" class="mb-0 text-secondary">
                          - domanda per l'operatore</span
                        >
                      </h6>
                    </b-col>
                    <b-col cols="12" class="text-justify">
                      <InputCompilatore
                        :identifier="'inputidentifier_' + ind"
                        :key="'inputidentifier_' + ind"
                        :question="domanda"
                        :index="ind"
                        :show-question="true"
                        @question-response="
                          template.template.domande[ind].a = $event
                        "
                      ></InputCompilatore>
                    </b-col>
                  </b-row>
                </template>
              </template>
            </template>
            <b-col class="my-4 py-2" key="btsubmt">
              <b-button @click="sendForm" :disabled="invalid" variant="secondary fw-bolder spacing_1">
                Invia</b-button
              >
            </b-col>
          </transition-group>
        </b-row>
      </b-form>
      </ValidationObserver>
    </div>
    <b-modal
      id="errori_compilazione"
      centered
      title="Attenzione!"
      ok-title="OK"
      ok-variant="popup-button"
      footer-border-variant="white"
      ok-only
    >
      <div class="my-3 px-2">
        <h5>{{ errorMessage }}</h5>
      </div>
    </b-modal>
  </div>
</template>
<script>
import SurveyUploader from "@/app/common/components/utilities/SurveyUploader.vue";
import CompilatoreRicognizione from "@/app/modules/servizi/screening/components/compilatore/CompilatoreRicognizione.vue";
import InputCompilatore from "@/app/modules/servizi/screening/components/compilatore/InputCompilatore.vue";
import { matchesResponse, isAnswerEmpty } from "@/_utils/survey_flow";
import { ValidationObserver } from 'vee-validate';
export default {
  name: "CompilatoreQuestionarioInLine",
  props: ["survey", "patient"],
  components: { SurveyUploader, CompilatoreRicognizione, InputCompilatore, ValidationObserver },
  data() {
    return {
      template: null,
      consent: false,
      proceed: false,
      file: null,
      tempTag: null,
      hasFocus: null,
      schemaRicognizione: null,
      schemaRicognizionePatologie: null,
      errorMessage: null,
    };
  },
  methods: {
    onFileChange(e) {
      this.file = e.target.files[0];
    },
    sendForm() {
      if (this.verifyRequired()) {
        this.template.template.ricognizione = this.schemaRicognizione;
        this.template.template.ricognizione_patologie = this.schemaRicognizionePatologie;
        this.$emit("filled-form", this.template);
      }
    },
    handleUpload(data, ind) {
      if (this.template.template.domande[ind].a == null) {
        this.template.template.domande[ind].a = [];
      }
      this.template.template.domande[ind].a.push(data.hashid);
      if (Array.isArray(data)) {
        this.template.template.domande[ind].a = data.map((el) => el.hashid);
      }
    },
    removeUpload(ind) {
      this.template.template.domande[ind].a = null;
    },
    addCustom(ind) {
      this.template.template.domande[ind].a.push(this.tempTag);
      this.tempTag = null;
    },
    setRicognizioneQuestions(data) {
      this.schemaRicognizione = data;
    },
    setRicognizionePatologieQuestions(data) {
      this.schemaRicognizionePatologie = data;
    },
    canBeShown(domanda) {
      if (!domanda.si && !domanda.hi) {
        return true;
      }
      // Confronto per inclusione: se la risposta referenziata è un array
      // (multiselect) la show-if matcha quando la risposta è tra le selezionate
      if (
        domanda.si &&
        matchesResponse(
          this.template.template.domande[domanda.si.index].a,
          domanda.si.response
        )
      ) {
        return (
          !domanda.hi ||
          (domanda.hi &&
            !matchesResponse(
              this.template.template.domande[domanda.hi.index].a,
              domanda.hi.response
            ))
        );
      }
      return false;
    },
    verifyRequired() {
      const questionGroup = this.template.template.domande;
      for (let x = 0; x < questionGroup.length; x++) {
        // Salta le domande non visibili (condizione si/hi non soddisfatta)
        if (!this.canBeShown(questionGroup[x])) {
          continue;
        }
        if (questionGroup[x].o != "ricognizione_patologie" && questionGroup[x].o != "ricognizione") {
          if (questionGroup[x].ric && questionGroup[x].ric.index != null) {
            const isRequired = typeof questionGroup[questionGroup[x].ric.index].a === "string" &&
              typeof questionGroup[x].ric.value === "string" &&
              questionGroup[questionGroup[x].ric.index].a?.toLowerCase() ===
              questionGroup[x].ric.value?.toLowerCase();
            if (isRequired && isAnswerEmpty(questionGroup[x].a)) {
              this.errorMessage = `Compila il campo obbligatorio per la domanda n°${
                x + 1
              }:"${questionGroup[x].q}"`;
              this.$bvModal.show("errori_compilazione");
              return false;
            }
          } else if (questionGroup[x].r && isAnswerEmpty(questionGroup[x].a)) {
            this.errorMessage = `Compila il campo obbligatorio per la domanda n°${
              x + 1
            }:"${questionGroup[x].q}"`;
            this.$bvModal.show("errori_compilazione");
            return false;
          }
        }
        else {
          let questionsRicognizionePatologie = [];
          if (questionGroup[x].o == "ricognizione_patologie") {
            questionsRicognizionePatologie = this.schemaRicognizionePatologie
          }
          else if(questionGroup[x].o == "ricognizione") {
            questionsRicognizionePatologie = this.schemaRicognizione
          }
          //console.log(questionsRicognizionePatologie)
          for (let y = 0; y < questionsRicognizionePatologie.length; y++) {
            for(var i in questionsRicognizionePatologie[y]) {
              //console.log(i)
              //console.log(questionsRicognizionePatologie[y][i])
            
              if (questionsRicognizionePatologie[y][i].ric && questionsRicognizionePatologie[y][i].ric.index) {
                  const isRequired = typeof questionsRicognizionePatologie[questionsRicognizionePatologie[y].ric.index][i].a === "string" &&
                    typeof questionsRicognizionePatologie[y][i].ric.value === "string" &&
                    questionsRicognizionePatologie[questionsRicognizionePatologie[y].ric.index][i].a?.toLowerCase() ===
                    questionsRicognizionePatologie[y][i].ric.value?.toLowerCase();
                  if (isRequired && isAnswerEmpty(questionsRicognizionePatologie[y][i].a)) {
                    this.errorMessage = `Compila il campo obbligatorio per la domanda n°${
                      x + 1
                    }:"${questionsRicognizionePatologie[y][i].q}"`;
                    this.$bvModal.show("errori_compilazione");
                    return false;
                  }
              } else if (questionsRicognizionePatologie[y][i].r && isAnswerEmpty(questionsRicognizionePatologie[y][i].a)) {
                console.log(questionsRicognizionePatologie[y][i])
                this.errorMessage = `Compila il campo obbligatorio per la domanda n°${
                  x + 1
                }:"${questionsRicognizionePatologie[y][i].q}"`;
                this.$bvModal.show("errori_compilazione");
                return false;
              }
            }
          }
        }
      }
      return true;
    },
  },
  created() {
    if (this.survey) {
      try {
        this.template = this.survey;
      } catch (err) {
        console.log(err);
      }
    }
  },
};
</script>
